import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { FormElementCreateService } from '../../services';
import { ToastResponse } from '../../utilities/ToastResponse';

export const fetchFormElementCreate = createAsyncThunk(
    'formElementCreate/fetchFormElementCreate',
    async ({ file, element, type, formId }) => {
        const response = await FormElementCreateService(file, element, type, formId)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
)

const formElementCreateSlice = createSlice({
    name: 'formElementCreate',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchFormElementCreate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchFormElementCreate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchFormElementCreate.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default formElementCreateSlice.reducer;
